import type { BankAccountResource } from "../../bank-account";
import type { CurrencyResource } from "../../currency";
import type { AccountingPostingPositionResource } from "../../accounting-posting";
import type { OrderResource } from "../../order";

export interface BankTransactionResource {
  id: string;
  bankAccount?: BankAccountResource;
  bank_account_id: string | null;
  currency_id: string | null;
  currency?: CurrencyResource;
  purpose: string | null;
  amount: string | null;
  amount_fee: string | null;
  date: string | null;
  valutadate: string | null;
  status: BankTransactionStatusEnum;
  remote_name: string | null;
  remote_bank_code: string | null;
  remote_account_number: string | null;
  accounting_posting_positions?: AccountingPostingPositionResource[];
  bank_transaction_order?: BankTransactionOrder;
  order?: OrderResource;
}

export type PaypalTransactionResource = {
  id: string;
  bank_account_id: string;
  bankAccount?: BankAccountResource;
  bank_transaction_id: string | null;
  bankTransaction?: BankTransactionResource | null;
  transaction_id: string;
  transaction_event_code: string;
  transaction_status: string;
  transaction_date: string | null;
  transaction_details: string;
  amount: string;
  amount_fee: string;
  invoice_id: string;
};

export type BankTransactionOrder = {
  id: string;
  order_id: string;
  bank_transaction_id: string;
  order?: OrderResource;
  bank_transaction?: BankTransactionResource;
};

export enum BankTransactionStatusEnum {
  Booked = "booked",
  NotBooked = "not_booked",
  OrderAssigned = "order_assigned",
}
